var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paysuce"},[_c('div',{staticClass:"paysuce_cont"},[_c('p'),_c('p',[_vm._v("您已支付成功")]),_c('p',[_vm._v("请前往“购卡记录”查看！")]),_c('div',[_c('div',[_c('router-link',{attrs:{"to":{name:'userCredits'}}},[_vm._v("继续购买")])],1),_c('div',[_c('router-link',{attrs:{"to":{name:'userCredits',query:{type:2}}}},[_vm._v("购卡记录")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }